import { computed, CUSTOM_ELEMENTS_SCHEMA, Component, input, output, signal } from '@angular/core';

import { FileItem } from 'ng2-file-upload';

import { AppSharedModule } from 'app/app-shared.module';
import {
  EnableClassTelemetry,
  EnableComponentTelemetry,
  injectComponentTelemetryService,
} from 'app/services/otel.service';
import { FileUploadComponent } from '../file-upload/file-upload.component';

@EnableClassTelemetry()
@Component({
  selector: 'app-import-dialog',
  imports: [AppSharedModule, FileUploadComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  templateUrl: './import-dialog.component.html',
  styleUrls: ['./import-dialog.component.scss'],
})
export class ImportDialogComponent<T> {
  @EnableComponentTelemetry() otelService = injectComponentTelemetryService();

  readonly isShowing = input<boolean>();
  readonly title = input<string>();
  readonly description = input<string>();
  readonly allowedExtensions = input<string[]>(['json']);
  readonly uploadNotes? = input<string[]>([]);
  readonly itemValidator =
    input<(fileUpload, importedItem) => { isValid: boolean; message: string }>();
  readonly notificationType = input<'paragraph' | 'snackbar'>('paragraph');
  readonly requiresConfirmation = input<boolean>(false);

  readonly modalClosed = output<{
    file: any;
    importedItem: T;
  }>();
  readonly filesConfirmed = output<{
    files: FileItem[];
    firstRecordAsHeader?: boolean;
  }>();

  readonly filesToConfirm = signal<FileItem[]>([]);
  readonly firstRowContainsData = signal<boolean>(true);
  readonly firstRowContainsDataToggleMimeTypes: string[] = ['text/csv'];
  readonly firstRowContainsDataToggleVisible = computed<boolean>(() =>
    this.filesToConfirm().some((file: FileItem) =>
      this.firstRowContainsDataToggleMimeTypes.includes(file.file.type)
    )
  );

  onFileConfirmation(result: { files?: FileItem[] }): void {
    this.filesToConfirm.update((files: FileItem[]) => [...files, ...(result.files ?? [])]);
  }

  onFirstRowContainsDataToggled(isToggled: boolean): void {
    this.firstRowContainsData.set(isToggled);
  }

  confirm(): void {
    const isFirstRowContainsData: boolean = this.firstRowContainsData();
    const isToggleVisible: boolean = this.firstRowContainsDataToggleVisible();
    this.filesConfirmed.emit({
      files: this.filesToConfirm(),
      firstRecordAsHeader: isToggleVisible && !isFirstRowContainsData,
    });
  }

  cancel(): void {
    this.modalClosed.emit(null);
  }
}
